import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { DATASET, IMPORT } from '../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { DSFieldRecord } from '../public/core';
import { conditionsGrouping } from './addingCondition';
import { isEventBasedFilterFamily } from '../strategy/eventBasedFilters';
import { parseDynamicFilterFamilyId, testDynamicFilterFamily } from '../filterQueryFormat/DynamicFilterFamilies';
import PortalIdParser from 'PortalIdParser';
const getViewDatasetURL = datasetId => {
  const portalId = PortalIdParser.get();
  return `/reporting-datasets/${portalId}/view/${datasetId}/fields?returnTo=all-datasets`;
};
const ENABLED_OBJECT_TYPE_IDS_FOR_IMPORT = [CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID];
const getViewImportURL = (importId, objectTypeId) => {
  if (!ENABLED_OBJECT_TYPE_IDS_FOR_IMPORT.includes(objectTypeId)) {
    return null;
  }
  const portalId = PortalIdParser.get();
  const filterOptions = JSON.stringify([{
    operator: 'IN',
    property: '_inbounddbio.importid_',
    values: [importId]
  }]);
  return `/contacts/${portalId}/objects/${objectTypeId}/views/all/list?filters=${encodeURIComponent(filterOptions)}`;
};
export const getHrefForAsset = (filterFamily, field) => {
  const isNotAnAsset = !conditionsGrouping.isAssetMembershipFilterFamily(filterFamily) && !isEventBasedFilterFamily(filterFamily);
  if (!DSFieldRecord.isDSFieldRecord(field) || isNotAnAsset) {
    return null;
  }
  if (testDynamicFilterFamily(DATASET, field.type)) {
    return getViewDatasetURL(field.name);
  }
  if (testDynamicFilterFamily(IMPORT, field.type)) {
    const objectTypeId = parseDynamicFilterFamilyId(IMPORT, field.type);
    return getViewImportURL(field.name, objectTypeId);
  }
  return field.url;
};